import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { BadgeCheck, Loader2 } from "lucide-react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { useStaffMessaging } from "@/hooks/useStaffMessaging";

/** Staff Messaging V1 — "Message as Startup Otter". Rendered ONLY for authorized staff;
 *  it opens (or reuses) the member's single official thread and jumps to the shared Staff
 *  Inbox with it selected. The ordinary personal Message action is untouched. */
export function StaffMessageButton({ targetUserId, className, size = "sm", variant = "secondary" }) {
  const { canStaffMessage } = useStaffMessaging();
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();

  if (!canStaffMessage || !targetUserId) return null;

  const go = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/staff-messaging/conversations", { target_user_id: targetUserId });
      navigate(`/dashboard/staff-inbox?c=${data.id}`);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Could not open the official conversation");
    } finally {
      setBusy(false);
    }
  };

  return (
    <Button variant={variant} size={size} className={className} onClick={go} disabled={busy}
            title="Message as Startup Otter" data-testid="staff-message-button">
      {busy ? <Loader2 className="mr-1.5 h-4 w-4 animate-spin" /> : <BadgeCheck className="mr-1.5 h-4 w-4" />}
      Message as Startup Otter
    </Button>
  );
}
